import React, { useState } from "react";
import { Button, Form, FloatingLabel, Alert, Spinner, Modal} from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "../CSS/Login.css";
import { AuthService } from "../Services/AuthService";
import { StorageUtils } from '../Utils/StorageUtils'; // Import the utility
import { useNavigate } from "react-router-dom";

const LoginScreen = ({
  show,
  handleClose,
  onForgotPassword,
  onSignupClicked,
}) => {
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(false); // Loader state
  const [errors, setErrors] = useState({});
  const [passwordVisible, setPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const resetForm = () => {
    
    setFormData({
      email: "",
      password: "",
    });
    setErrors({});
    setApiResponse(null);
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email address";
    if (!formData.password) newErrors.password = "Password is required";
    else if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";
    return newErrors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true); // Start loader
        const response = await AuthService.login({
          email: formData.email,
          password: formData.password,
        });
        // Use comprehensive save that clears cache
        StorageUtils.saveUserDataAndRefresh(response.data);
        console.log('🎆 Login successful - user data saved with fresh cache:', response.data);
        setApiResponse(response.data);
        setTimeout(() => {
          resetForm();
          window.dispatchEvent(new Event('storage'));
          // navigate('/');
           navigate('/dashboard');
          
          
          handleClose();
        }, 2000);
      } catch (error) {
        setApiResponse({
          error: error.response?.data?.message || "Login failed",
        });
      } finally {
        setLoading(false); // Stop loader
      }
      // No validation errors, proceed with form submission
      console.log("Form submitted successfully!", formData);
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={() => {
        resetForm();
        handleClose();
      }} 
      centered
    >
      <Modal.Header closeButton className="border-0"></Modal.Header>
      <Modal.Body>
        <h2 className="custom-heading-login"> Welcome back! </h2>
        <p className="custom-sub-heading-login">
          Enter your Credentials to access your account
        </p>
        <Form onSubmit={handleSubmit}>
          {/* Email */}
          <Form.Group
            controlId="formEmail"
            className="floating-label-custom mb-3"
          >
            <FloatingLabel label="Email Address">
              <Form.Control
                type="email"
                placeholder="Enter your email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {" "}
                {errors.email}{" "}
              </Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>

          {/* Password */}
          <Form.Group
            controlId="formPassword"
            className="floating-label-custom mb-3"
          >
            <FloatingLabel label="Password">
              <Form.Control
                type={passwordVisible ? "text" : "password"}
                placeholder="Enter your password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {" "}
                {errors.password}{" "}
              </Form.Control.Feedback>
              <Button
                variant="outline-secondary"
                onClick={togglePasswordVisibility}
                className="toggle-password-visibility"
              >
                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </FloatingLabel>
          </Form.Group>

          <div className="d-flex justify-content-between align-items-center">
            {/* Remember Me */}
            <Form.Group
              controlId="formRememberMe"
              className="custom-checkbox mb-3"
            >
              <Form.Check type="checkbox" label="Remember Me" />
            </Form.Group>
            {/* Forgot Password */}

            <Button
              variant="link"
              className="custom-forgot-password-button-login"
              onClick={onForgotPassword}
            >
              Forgot Password?
            </Button>
          </div>

          {/* Login Button */}
          <Button
            variant="primary"
            type="submit"
            className="custom-login-button-login w-100 mb-3" disabled={loading}
          >
              {loading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        {' Please Wait...'}
                      </>
                    ) : (
                      'Sign In'
                    )}
          </Button>
              {/* API Response */}
      {apiResponse && (
        <Alert variant={apiResponse.error ? 'danger' : 'success'} className="mt-3">
          {apiResponse.error || 'Login successful!'}
        </Alert>
      )}
        </Form>

        <p className="custom-anchor">
          Don't have an account already?{" "}
          <a
            href="#"
            className="custom-anchor-login text-decoration-underline"
            onClick={onSignupClicked}
          >
            Sign Up here
          </a>{" "}
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default LoginScreen;
